import {Typography, WithStyles, withStyles} from '@material-ui/core';
import Button from "@components/common/button/Button";
import TranslateNew from '@translate/TranslateNew';
import * as React from "react";
import {FormEvent} from "react";
import {connect} from "react-redux";
import Input from "@components/common/input/input.component";
import {AddCoparentStyles} from "@components/onboarding/steps/StepAddCoparent/addCoparent.styles";
import ProgressBar from "@components/common/progressBar/progressBar";
import {signupAddFamilyMember} from '@services/family/family.actions';
import cordovaContext from "src/cordovaContext";
import { IFamilyMember } from '@app-types/websocket/family.types';
import * as FamilyActions from '@services/family/family.actions';
import { FamilyMemberType } from '@services/family/family.constants';

const tn: TranslateNew = TranslateNew.getInstance();

interface IAddCoparentProps extends WithStyles<typeof AddCoparentStyles> {
    nextStep: (customStep?: number) => void;
    progress?: number | undefined;
    addFamilyMember: (data: object) => void;
    extendedFamily:IFamilyMember[];
    addUser: (data: IFamilyMember) => void;
}

interface IAddCoparentState {
    formValues: {
        firstName: string;
    };
    formErrors: {
        firstName?: string | undefined,
    };
    isFocus : boolean;
}

class AddCoparent extends React.Component<IAddCoparentProps, IAddCoparentState> {

    constructor(props: any) {
        super(props);

        this.state = {
            isFocus:false,
            formValues: {
                firstName: "",
            },
            formErrors: {
                firstName: undefined,
            },
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleInputBlur = this.handleInputBlur.bind(this);
        this.validateFirstName = this.validateFirstName.bind(this);
    }

    public render() {
        const {formErrors, formValues} = this.state;
        const style = this.props.classes;
        const isCordovaApp = this.context;

        const options:JSX.Element[] = this.props.extendedFamily.map((mem,ind) => 
            <Button key={ind}
                variant='outlined'
                size="large"
                title='test'
                style={ind === 0?{marginTop:24}:{}}
                fullWidth={true}
                onClick={() => this.handleAddExistingAsParent(mem)}
            >
                {mem.firstName}
                <span style={{position: 'absolute', bottom: '3px', opacity: 0.5, fontSize: '8px'}}>{tn.lang.onbExistingAccount}</span>
            </Button>)

        return (
            <div className={style.root}>
                <div className={style.background} style={(this.state.isFocus && isCordovaApp)?{paddingBottom:'300px'}:{}}>
                    <div className={style.circle}/>
                </div>
                <div className={style.container}>
                    <div className={style.topBar}>
                        {this.props.progress && (<ProgressBar  value={this.props.progress}/>)}
                    </div>
                    <div className={style.topContent}>
                        <Typography variant="h2">{tn.lang.onbCoparentTitle}</Typography>
                        {(options.length === 0) && <Typography>
                            {tn.lang.onbCoparentText}
                        </Typography>}
                    </div>
                    <form className={style.form} onSubmit={this.handleSubmit}>
                        <div className={style.formMiddleContent}>
                            <Input
                                id="firstName"
                                name="firstName"
                                type="text"
                                autoComplete="first-name"
                                onChange={this.handleInputChange}
                                onBlur={this.handleInputBlur}
                                onFocus={() => this.setState({isFocus:true})}
                                value={formValues.firstName}
                                label={tn.lang.labelFirstName}
                                error={formErrors.firstName}
                            />
                            {options}
                        </div>
                        <div className={style.formBottomContent}>
                            <Button
                                type="submit"
                                variant='contained'
                                color='primary'
                                size="large"
                                fullWidth={true}
                            >
                                {tn.lang.continue}
                            </Button>
                        </div>
                    </form>
                </div>

            </div>
        );
    }

    private validateFirstName = (): boolean => {
        const {formValues} = this.state;

        if (!formValues.firstName) {
            this.setState((prevState) => ({
                formErrors: {
                    ...prevState.formErrors,
                    firstName: tn.lang.validationSirNameRequired,
                },
            }));
            return false;
        } else if (formValues.firstName.length < 2) {
            this.setState((prevState) => ({
                formErrors: {
                    ...prevState.formErrors,
                    firstName: tn.lang.validationFirstNameInvalid,
                },
            }));
            return false;
        }

        this.setState((prevState) => ({
            formErrors: {
                ...prevState.formErrors,
                firstName: undefined,
            },
        }));
        return true;
    }

    private handleAddExistingAsParent = async (person:IFamilyMember) => {

        const newMember:IFamilyMember = {...person, role:FamilyMemberType.PARENT};
        try {
            await this.props.addUser(newMember);
            this.props.nextStep();
        } catch (error) {
            console.error(error);
        }
    }

    private handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const isFirstNameValid = this.validateFirstName();

        if (isFirstNameValid) {
            try {
                await this.props.addFamilyMember({...this.state.formValues});
            } catch (error) {
                console.error(error);
            }
        }
    }

    private handleInputBlur = (event: React.FormEvent<HTMLInputElement>) => {
        const {name} = event.currentTarget;
        this.setState({isFocus:false})
        switch (name) {
            case 'firstName':
                this.validateFirstName();
                break;
        }
    }

    private handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const {name, value, type, checked} = event.target;
        const inputValue = type === 'checkbox' ? checked : value;
        this.setState((prevState) => ({
            formValues: {
                ...prevState.formValues,
                [name]: inputValue,
            },
            formErrors: {
                [name]: undefined,
            },
        }));
    }
}

const mapDispatchToProps = {
    addFamilyMember: signupAddFamilyMember,
    addUser: FamilyActions.addUser,
};

function mapStateToProps(state: any) {

  const extendedFamily:IFamilyMember[] = [];

  if (state.user && state.user.session && state.family.family) {
    const userId = state.user.session.data.id;
    const family: IFamilyMember[] = state.family.family;

    if (state.user.session?.data?.resources && state.user.session.data.resources.length > 1) {
    if (state.user.session.extendedFamily) {
      for (const eFam of state.user.session.extendedFamily) {
        if (eFam.id === userId) { continue;}
        if (family.findIndex((mem) => mem.id === eFam.id) !== -1) {continue;}
        if (eFam.role !== FamilyMemberType.VIEWER) {
          continue;
        }
        extendedFamily.push(eFam);
      }
    }
  }
  }

  return {
    extendedFamily,
  };
}

AddCoparent.contextType = cordovaContext;

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(AddCoparentStyles)(AddCoparent));



// WEBPACK FOOTER //
// ./src/components/onboarding/steps/StepAddCoparent/addCoparent.component.tsx